/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

// window.Vue = require('vue');
// window.VueI18n = require('vue-i18n');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
// Vuetify
// import '@mdi/font/css/materialdesignicons.css'
// import 'vuetify/styles'
// import { createVuetify } from 'vuetify'
// import * as components from 'vuetify/components'
// import * as directives from 'vuetify/directives'
// Vuex store
// import store from './store/index.js';
// i18n
// import { i18n, elLang } from "./i18n";
/*
const app = Vue.createApp({
    components: {
        // 'example-component': require('./components/ExampleComponent.vue').default,
        // 'full-screen-loading': require('./components/FullScreenLoading.vue').default,
        // 'article-list': require('./components/articles/ArticleList.vue').default,
        // 'ratio-image': require('./components/RatioImage.vue').default,
        // 'iframe-video': require('./components/IframeVideo.vue').default,
        // 'top-iframe-video': require('./components/TopIframeVideo.vue').default,
        // 'search-infinite': require('./components/SearchInfinite.vue').default,
    }
});
*/
// app.use(store);
// app.use(i18n);
// app.use(ElementPlus, {
//     locale: elLang,
// });
/*
// 條件性動態加載 Vuetify (`Vuetify3`不好用，放棄)
if (document.body.dataset.useVuetify === "true") {
    // const vuetify = createVuetify({
    //     components,
    //     // directives
    // });
    // app.use(vuetify);
    finishAppSetup();
} else {
    finishAppSetup();
}

function finishAppSetup() {
    // 清除 <body> 內的 <link>、<style>、<meta>、<title>、<script>
    function cleanMainRedundantElements() {
        const elements = document.querySelector('#main').querySelectorAll('link, style, meta, title, script');
        elements.forEach(el => {
            el.remove();
        });
    }
    try {
        cleanMainRedundantElements();
    } catch (error) {
        console.error("`cleanMainRedundants()` error", error);
    }
    // img、iframe 的 width、height 如果是 (%) 被 Vue 覆蓋的問題 (用 style 複寫)
    function setMainElementDimensions() {
        const elements = document.querySelector('#main').querySelectorAll('img, iframe, video');
        elements.forEach(el => {
            const width = el.getAttribute('width');
            const height = el.getAttribute('height');
            if (width && width.endsWith('%')) {
                el.style.width = width;
            }
            if (height && height.endsWith('%')) {
                el.style.height = height;
            }
        });
    }
    try {
        setMainElementDimensions();
    } catch (error) {
        console.error("`setMainElementDimensions()` error", error);
    }
    app.config.compilerOptions.isCustomElement = tag => tag === 'font';
    app.mount('#main');
}
*/